import React, { useRef } from "react";
import * as S from "../CondensedFeatureGrid.styles";
import { useTranslation } from "hooks/useTranslation";
import { useMenu } from "@ubnt/store.core/lib/contexts/MenuContext";
import { Language } from "@ubnt/store.core/lib/types";
import { ArrowRightMicroIcon } from "@ubnt/icons";
import { ProgressiveBlurGradient } from "components/ProgressiveBlurGradient";
import { ICondensedFeatureGridCardProps } from "./CondensedFeatureGridCard.types";
import { VideoItem } from "./VideoItem";

export const CondensedFeatureGridCard = ({
  card,
  isActive,
  isInView,
  itemsCountInRow,
  itemsPerRow,
  isOverview,
  onSelectCard,
}: Readonly<ICondensedFeatureGridCardProps>) => {
  const { t } = useTranslation();
  const { language } = useMenu();

  const cardRef = useRef(null);

  return (
    <S.CardWrap
      ref={cardRef}
      $isOpen={isActive}
      $hasLessThanMaxItems={itemsCountInRow < itemsPerRow}
    >
      <S.Card
        $isOpen={isActive}
        $variant={card.variant}
        onClick={() => onSelectCard(card)}
      >
        <S.ContentWrapper
          $isSelectedModelsOnly={card.isSelectedModelsOnly}
          $isComingSoon={card.isComingSoon}
        >
          {card.assets.icon}
          <S.CardTitle
            $isActive={isActive}
            $isOtherLanguage={language !== Language.En}
            dangerouslySetInnerHTML={{ __html: t(card.title) }}
          />
          <S.CardDescription
            $isOverview={isOverview}
            dangerouslySetInnerHTML={{ __html: t(card.description) }}
          />
        </S.ContentWrapper>

        {card.isComingSoon && (
          <S.FeatureCardDisclaimer>
            {t("commons.comingSoonNote")}
          </S.FeatureCardDisclaimer>
        )}
        {card.isSelectedModelsOnly && (
          <S.FeatureCardDisclaimer>
            {t("commons.selectedModels")}
          </S.FeatureCardDisclaimer>
        )}

        <S.ToggleBtn $isActive={isActive} $variant={card.variant}>
          <ArrowRightMicroIcon size={22} variant="fill" />
        </S.ToggleBtn>

        <S.VideoWrapper>
          {isActive && (
            <ProgressiveBlurGradient
              variant={card.variant}
              isRounded
              maxWidth="50%"
            />
          )}
          <VideoItem isActive={isActive} card={card} isInView={isInView} />
        </S.VideoWrapper>
      </S.Card>
    </S.CardWrap>
  );
};
